<template>
  <div class="row myrow content-mb-42">
    <div class="col-xs-12 mycol">
      <table class="co-executor">
        <thead>
          <tr>
            <td>№ п/п</td>
            <td>
              Продукт проекта
            </td>
            <td style="padding-left: 10px;">
              Количество, шт
            </td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in project.PROVIDING_MOBILIZATION_NEEDS.items"
          >
            <td>{{ index + 1 }}</td>
            <td
              v-bind:class="{
                'has-error': hasError(index, 'UF_PROJECT_PRODUCT_ID')
              }"
            >
              <input type="hidden" v-model="item.ID" />
              <select
                @change="removeError(index, 'UF_PROJECT_PRODUCT_ID')"
                v-model="item.UF_PROJECT_PRODUCT_ID"
                class="sel-dropdown i-main-style"
                style="width: 100%"
              >
                <option
                  v-for="g in $parent.directory
                    .sp_project_products_mobilization_list"
                  v-bind:value="g.ID"
                  v-bind:key="g.ID"
                  v-text="g.NAME"
                ></option>
              </select>
              <div class="error-text">
                {{ errorText(index, "UF_PROJECT_PRODUCT_ID") }}
              </div>
            </td>
            <td
              v-bind:class="{
                'has-error': hasError(index, 'UF_COUNT')
              }"
              style="padding-left: 10px;"
            >
              <input
                type="text"
                class="i-main-style i-co-executor-style"
                :disabled="$parent.$parent.projectDisabled"
                @keyup="removeError(index, 'UF_COUNT')"
                v-model="item.UF_COUNT"
                @keypress="isNumber($event)"
              />

              <div class="error-text">
                {{ errorText(index, "UF_COUNT") }}
              </div>
            </td>
            <td>
              <a
                v-show="!$parent.$parent.projectDisabled"
                v-on:click="deleteItem(index)"
                class="link-delete-row"
              ></a>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="add-row" v-show="!$parent.$parent.projectDisabled">
        <a class="link-add-row" v-on:click="addItem">Добавить продукт</a>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
//import { FETCH_DIRECTORY } from "@/store/actions.type";
import { mapGetters } from "vuex";

export default {
  name: "providing_mobilization_needs",
  props: ["project"],
  methods: {
    hasError(col, field) {
      if (
        typeof this.$parent.$parent.providingMobilizationNeeds[col] !==
        "undefined"
      ) {
        if (
          typeof this.$parent.$parent.providingMobilizationNeeds[col][field] !==
          "undefined"
        ) {
          return true;
        }
      }
      return false;
    },
    errorText(col, field) {
      if (
        typeof this.$parent.$parent.providingMobilizationNeeds[col] !==
        "undefined"
      ) {
        if (
          typeof this.$parent.$parent.providingMobilizationNeeds[col][field] !==
          "undefined"
        ) {
          return this.$parent.$parent.providingMobilizationNeeds[col][field];
        }
      }
      return "";
    },
    removeError(col, field) {
      if (
        typeof this.$parent.$parent.providingMobilizationNeeds[col] !==
        "undefined"
      ) {
        if (
          typeof this.$parent.$parent.providingMobilizationNeeds[col][field] !==
          "undefined"
        ) {
          Vue.delete(
            this.$parent.$parent.providingMobilizationNeeds[col],
            field
          );
        }
      }
      return false;
    },
    addItem() {
      if (typeof this.project.PROVIDING_MOBILIZATION_NEEDS === "undefined") {
        this.project.PROVIDING_MOBILIZATION_NEEDS = {
          items: []
        };
      } else {
        this.project.PROVIDING_MOBILIZATION_NEEDS.items.push({});
      }
    },
    deleteItem(index) {
      this.project.PROVIDING_MOBILIZATION_NEEDS.items.splice(index, 1);
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  },
  computed: {
    ...mapGetters(["directory"])
  }
};
</script>

<style scoped></style>
